import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Connexion from '../../composant/Connexion/Connexion';
import AlerteAffichage from '../../composant/UI/AlerteAffichage/AlerteAffichage';
import * as actions from '../../services/actions';
import ConteneurCentral from '../ConteneurCentral/ConteneurCentral';
import Menu from '../Menu/Menu';

const MiseEnPage = () => {
  // State management with useState
  const [showMenu, setShowMenu] = useState(true);

  // Redux dispatch hook
  const dispatch = useDispatch();

  // Event handler for menu toggle
  const handleMenuToggle = () => {
    setShowMenu((prevShowMenu) => {
      if (!prevShowMenu) {
        dispatch(actions.ouvertureMenuGauche());
      } else {
        dispatch(actions.fermetureMenuGauche());
      }
      return !prevShowMenu;
    });
  };

  return (
    <>
      <Menu ouvert={showMenu} commutateur={handleMenuToggle} />
      <ConteneurCentral montrerMenu={showMenu} />
      <Connexion />
      <AlerteAffichage />
    </>
  );
};

export default MiseEnPage;
